interface LastAddedBlockResult {
  state_root_hash: string;
  height: number;
  timestamp: string;
  era_id: number;
}

interface LastSwitchBlockResult {
  timestamp: string;
}
export interface StatusResult {
  build_version: string;
  last_progress: string;
  last_added_block: LastAddedBlockResult;
  last_switch_block: LastSwitchBlockResult;
}

export enum NetworkMajorVersion {
  'V1' = '1',
  'V2' = '2',
}
